import React            from 'react';

import { browserHistory } from 'react-router';

class HouseAndLandReducer extends React.Component {
	constructor(props) {
		super(props);
	}

	componentWillMount() {
		this.props.router.push('/house-and-land');
	}
	render () {
		return null
	}
}
export default HouseAndLandReducer;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/HouseAndLandRedirect.js
 **/